<div mat-dialog-title class="ted-title">
  <mat-icon class="dialog-icon">error_outline</mat-icon>
  <span>{{ title }}</span>
</div>

<mat-dialog-content class="ted-content">
  <p class="ted-headline">{{ analysis?.headline }}</p>

  <div *ngIf="cause.length > 0" class="ted-section">
    <div class="ted-section-title">Where the problem is</div>
    <div *ngFor="let f of cause" class="ted-finding ted-cause">
      <div class="ted-where"><span class="ted-badge">{{ f.title }}</span>{{ f.where }}</div>
      <div class="ted-problem">{{ f.problem }}</div>
      <div class="ted-fix"><span class="ted-label">Fix:</span> {{ f.fix }}</div>
      <div *ngIf="f.examples?.length" class="ted-examples">
        <div *ngFor="let e of f.examples">{{ e }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="otherFindings.length > 0" class="ted-section">
    <div class="ted-section-title">{{ cause.length > 0 ? 'Also found' : 'Problems found' }}</div>
    <div *ngFor="let f of otherFindings" class="ted-finding">
      <div class="ted-where"><span class="ted-badge">{{ f.title }}</span>{{ f.where }}</div>
      <div class="ted-problem">{{ f.problem }}</div>
      <div class="ted-fix"><span class="ted-label">Fix:</span> {{ f.fix }}</div>
      <div *ngIf="f.examples?.length" class="ted-examples">
        <div *ngFor="let e of f.examples">{{ e }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="analysis?.engineIssue" class="ted-section ted-report">
    This looks like a DTR engine issue. Please report it to
    <a [href]="reportLink" class="ted-link">{{ analysis?.reportTo }}</a>
    with the technical details below.
  </div>

  <mat-expansion-panel class="ted-details" *ngIf="hasTechnical">
    <mat-expansion-panel-header>
      <mat-panel-title>Technical details (may be a bit extreme)</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <pre class="ted-pre">{{ technicalText }}</pre>
    </ng-template>
  </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="ok-button" *ngIf="hasTechnical" (click)="copyDetails()">{{ copied ? 'Copied' : 'Copy details' }}</button>
  <button mat-stroked-button class="ok-button" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
